import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_97e4d315-fb68-411c-ab5c-99807b383276/artifacts/abs7uaow_IMG_0766.png";

export const CATEGORIES = [
  { key: "music", label: "Music Artists", icon: "Mic2" },
  { key: "models", label: "Models", icon: "Crown" },
  { key: "athletes", label: "Athletes", icon: "Trophy" },
  { key: "business", label: "Business Owners", icon: "Briefcase" },
  { key: "film", label: "Film & Entertainment", icon: "Clapperboard" },
];

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
